(function(angular){
    'use strict';

    angular.module('core').directive('unsavedIndicator', ['$translate', function($translate){
        return {
            restrict: 'E',
            scope: {
                toggle: '=',
                tabname: '='
            },
            templateUrl: 'common/unsaved-indicator/unsaved-indicator.html',
            link: function(scope){
                // translate the unsaved text
                $translate('Onvio.Setup.Client.Notifications.UnsavedChanges').then(function(value){
                    scope.unsavedTranslated = value;
                });
            }
        };
    }]);
})(window.angular);
